import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { LeadModal } from '@telialt/common-lead/src';

export const useAskToUnRestrictLeasingModalControls = () => useBrowserModalControls('AskToUnRestrictLeasing');

export const AskToUnRestrictLeasingModal = () => {
    const { isModalOpen, closeModal } = useAskToUnRestrictLeasingModalControls();

    return <LeadModal isOpen={isModalOpen} onClose={closeModal} />;
};
